const sigin = {
	banner: [{
		tips:'注册',
		title:'注册',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),
	}],	
	label:{
		nickName:'姓名',
		userName:'账号',
		phonenumber:'手机号码',
		password:'密码',
		email:'邮箱',
		code:'验证码',
		submit_btn:'注册',
		get_code:'获取验证码',
		send_success:'验证码已发送',
		phonenumber_tips:"请输入手机号码",
		signSuccess:'注册成功'
	},
	placeholder:{
		nickName:'请输入姓名',
		userName:'请输入账号',
		phonenumber:'请输入手机号码',
		password:'请输入密码',
		email:'请输入邮箱',
		code:'请输入验证码',
	},
	rules:{
		nickName:	[{ required: true, message:'请输入姓名', trigger: 'blur' },],
		userName:	[{ required: true, message:'请输入账号', trigger: 'blur' },],	
		phonenumber:	[
			{ required: true, message:'请输入手机号码', trigger: 'blur' },
			{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码",trigger: "blur"}
		],
		password:	[{ required: true, message:'请请输入密码', trigger: 'blur' },],
		code:	[{ required: true, message:'请输入验证码', trigger: 'blur' },]
	}
}

export default sigin